<section class="hero-section">
  <div class="floating-elements">
    <div class="floating-element"></div>
    <div class="floating-element"></div>
    <div class="floating-element"></div>
  </div>
  
  <div class="container">
    <div class="row align-items-center min-vh-100">
      <div class="col-lg-6">
        <div class="hero-content">
          <h1 class="hero-title fade-in">
            Moderne Sanitär- & Heizungstechnik
          </h1>
          <p class="hero-subtitle fade-in">
            Digitale Lösungen für Ihr Zuhause. Wir verbinden Tradition mit Innovation 
            und bieten Ihnen zukunftsweisende Sanitär- und Heizungstechnik.
          </p>
          <div class="hero-buttons fade-in">
            <a routerLink="/contact" class="btn btn-cta">
              Jetzt Beratung anfragen
            </a>
            <button class="btn btn-outline" (click)="scrollToServices()">
              Dienstleistungen entdecken
            </button>
          </div>
        </div>
      </div>
      
      <div class="col-lg-6">
        <div class="hero-visual fade-in">
          <div class="tech-icon">
            <i class="fas fa-tools"></i>
          </div>
          <div class="floating-icons">
            <div class="icon-item">
              <i class="fas fa-fire"></i>
            </div>
            <div class="icon-item">
              <i class="fas fa-bath"></i>
            </div>
            <div class="icon-item">
              <i class="fas fa-wrench"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>